<template>
<div class="ticket-pool-page">
    <van-nav-bar title="订单池" fixed :placeholder="true">
        <template #right>
            <van-icon name="filter-o" size="18" @click="showFilter = true" />
        </template>
    </van-nav-bar>

    <!-- 顶部筛选栏 -->
    <div class="filter-bar">
        <div class="filter-scroll">
            <div class="filter-item" 
                 v-for="(item, index) in filterItems" 
                 :key="index" 
                 @click="handleFilterClick(item.type, $event)"
                 :class="{ 'active': activeFilter === item.type }">
                <template v-if="item.type === 'province'">
                    <span class="filter-text" v-if="!selectedProvinceNames">省份</span>
                    <span class="filter-text" v-else>{{ selectedProvinceNames }}</span>
                </template>
                <template v-if="item.type === 'city'">
                    <span class="filter-text" v-if="!selectedCityNames">{{ item.name }}</span>
                    <span class="filter-text" v-else>{{ selectedCityNames }}</span>
                </template>
                <template v-else-if="item.type === 'movie'">
                    <span class="filter-text" v-if="!selectedMovieNames">{{ item.name }}</span>
                    <span class="filter-text" v-else>{{ selectedMovieNames }}</span>
                </template>
                <template v-else-if="item.type === 'seat'">
                    <span class="filter-text" v-if="!selectedSeatType">{{ item.name }}</span>
                    <span class="filter-text" v-else>{{ selectedSeatType }}</span>
                </template>
                <template v-else-if="item.type !== 'province'">
                    <span class="filter-text">{{ item.name }}</span>
                </template>
                <van-icon :name="activeFilter === item.type ? 'arrow-up' : 'arrow-down'" />
            </div>
        </div>
    </div>

    <div class="home-wrap page-with-tabbar">
        <van-pull-refresh v-model="refresh" @refresh="onRefresh" style="height: 100% !important;">
            <van-skeleton v-if="loading && tableData.length === 0" class="product-skeleton" title :row="6" />
            <div v-for="(item, index) in tableData" :key="item.order_id || index" class="order-card-outer">
                <div class="order-card-strict" :class="{ 'expired': item.isFinished }" @click="handleCardClick(item, $event)">
                    <!-- 上部分 -->
                    <div class="order-card-top">
                        <div class="top-left">
                            <div class="cinema-name">{{ item.cinema_name }}</div>
                            <div class="hall-name">{{ item.hall_name }}</div>
                        </div>
                        <div class="top-right">
                            <div class="market-price">
                                <span>市场价:</span><span class="market-price-num">￥{{ item.channel_price }}</span>
                            </div>
                            <div class="max-price">最高限价:￥{{ item.order_price }}</div>
                        </div>
                    </div>
                    <!-- 分割线 -->
                    <div class="order-card-divider"></div>
                    <!-- 下部分 -->
                    <div class="order-card-bottom">
                        <div class="bottom-left">
                            <div class="movie-img-box">
                                <van-image width="80px" height="100%" fit="cover" :src="item.logo+'_200x200'" />
                            </div>
                            <div class="movie-info-box">
                                <div class="movie-title">{{ item.movie_name }}</div>
                                <div class="movie-tags">
                                    <span class="ticket-count">{{ item.quantity }}张</span>
                                    <span v-if="item.support_exchange_seat == 'Y'" class="seat-type-tag">九宫格换座</span>
                                    <span v-if="item.seatTag === '2'" class="seat-type-tag couple-seat">情侣座</span>
                                   
                                </div>
                                <div class="showtime-row">
                                    <span class="today-tag" v-if="item.play_date_tag">{{ item.play_date_tag }}</span>
                                    <span class="showtime">{{ item.play_time_text }}</span>
                                </div>
                                <div class="bidder-row">
                                    <span>竞价人数：</span><span class="bidder-count">{{ item.bid_count || 0 }}人</span>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-right">
                            <div class="city-name">{{ item.city_name }}</div>
                            <van-button
                                color="#ff2c54"
                                size="small"
                                class="bid-btn-strict bottom-right"
                                @click.stop="openBidDialog(item)"
                                :disabled="item.isFinished"
                            >
                                <strong>报价</strong>
                                <template v-if="!item.isFinished">
                                    <van-count-down
                                        :time="item.remaining * 1000"
                                        format="mm:ss"
                                        style="font: bold 1em sans-serif; color: white;"
                                        @finish="item.isFinished = true"
                                    />
                                </template>
                                <template v-else>
                                    <span style="font: bold 1em sans-serif; color: white;">结束</span>
                                </template>
                            </van-button>
                        </div>
                    </div>
                </div>
            </div>
            <van-empty v-if="!loading && tableData.length === 0" class="product-empty" image="search" :description="loadError ? '加载失败，请检查网络后重试' : '当前筛选条件下暂无订单'">
                <van-button size="small" plain type="primary" @click="fetchData">重新加载</van-button>
            </van-empty>
        </van-pull-refresh>
    </div>

    <!-- 右侧筛选抽屉 -->
    <van-popup v-model="showFilter" position="right" :style="{ width: '85%', height: '100%' }">
        <div class="filter-drawer">
            <div class="drawer-header">
                <span>筛选条件</span>
                <van-icon name="cross" @click="showFilter = false" />
            </div>
            
            <div class="drawer-content">
                <div class="filter-section">
                    <div class="section-header">
                        <div class="section-title">
                            <van-icon name="location" class="section-icon" />
                            省份
                        </div>
                        <div class="section-expand" @click="toggleDrawerProvinceExpand">
                            <span>{{ isDrawerProvinceExpanded ? '收起' : '展开' }}</span>
                            <van-icon :name="isDrawerProvinceExpanded ? 'arrow-up' : 'arrow-down'" />
                        </div>
                    </div>
                    <div class="drawer-province-grid" :class="{ 'collapsed': !isDrawerProvinceExpanded }">
                        <div 
                            v-for="(province, index) in provinces" 
                            :key="province.id"
                            class="province-item"
                            :class="{ 'active': tempSelectedProvinces.includes(province.id) }"
                            @click="toggleProvince(province.id)"
                            v-show="!isDrawerProvinceExpanded ? index < 6 : true"
                        >
                            {{ province.name }}
                        </div>
                    </div>
                </div>

                <div class="filter-section">
                    <div class="section-header">
                        <div class="section-title">
                            <van-icon name="cluster" class="section-icon" />
                            城市
                        </div>
                        <div class="section-expand" @click="toggleDrawerCityExpand">
                            <span>{{ isDrawerCityExpanded ? '收起' : '展开' }}</span>
                            <van-icon :name="isDrawerCityExpanded ? 'arrow-up' : 'arrow-down'" />
                        </div>
                    </div>
                    <div class="drawer-city-grid" :class="{ 'collapsed': !isDrawerCityExpanded }">
                        <div 
                            v-for="(city, index) in cities" 
                            :key="city.city_code"
                            class="city-item"
                            :class="{ 'active': tempSelectedCities.includes(city.city_code) }"
                            @click="toggleCity(city)"
                            v-show="!isDrawerCityExpanded ? index < 6 : true"
                        >
                            {{ city.name }}
                        </div>
                    </div>
                </div>

                <div class="filter-section">
                    <div class="section-header">
                        <div class="section-title">
                            <van-icon name="shop" class="section-icon" />
                            影院
                        </div>
                        <div class="section-expand" @click="addCinemaInput">
                            <span>添加</span>
                            <van-icon name="plus" />
                        </div>
                    </div>
                    <div class="cinema-inputs-grid">
                        <div v-for="(input, index) in cinemaInputs" :key="index" class="cinema-input-item">
                            <van-field
                                v-model="input.value"
                                placeholder="请输入影院名称"
                                class="cinema-field"
                            >
                                <template #right-icon>
                                    <van-icon 
                                        v-if="index !== 0" 
                                        name="cross" 
                                        @click.stop="removeCinemaInput(index)" 
                                        class="remove-icon"
                                    />
                                </template>
                            </van-field>
                        </div>
                    </div>
                </div>

                <div class="filter-section">
                    <div class="section-header">
                        <div class="section-title">
                            <van-icon name="apps-o" class="section-icon" />
                            影院分类
                        </div>
                    </div>
                    <div class="drawer-cinema-type-grid">
                        <div 
                            v-for="type in cinemaTypes" 
                            :key="type.id"
                            class="cinema-type-item"
                            :class="{ 'active': tempSelectedCinemaTypes.includes(type.id) }"
                            @click="toggleCinemaType(type.id)"
                        >
                            {{ type.name }}
                        </div>
                    </div>
                </div>

                <div class="filter-section">
                    <div class="section-header">
                        <div class="section-title">
                            <van-icon name="video" class="section-icon" />
                            影片
                        </div>
                        <div class="section-expand" @click="toggleDrawerMovieExpand">
                            <span>{{ isDrawerMovieExpanded ? '收起' : '展开' }}</span>
                            <van-icon :name="isDrawerMovieExpanded ? 'arrow-up' : 'arrow-down'" />
                        </div>
                    </div>
                </div>
                <div class="drawer-movie-grid" :class="{ 'collapsed': !isDrawerMovieExpanded }">
                    <div 
                        v-for="(movie, index) in movies" 
                        :key="movie.ID"
                        class="movie-item"
                        :class="{ 'active': tempSelectedMovies.includes(movie.ID) }"
                        @click="toggleMovie(movie)"
                        v-show="!isDrawerMovieExpanded ? index < 6 : true"
                    >
                        {{ movie.name }}
                    </div>
                </div>

                <div class="filter-section">
                    <div class="section-title">
                        <div class="section-title">
                            <van-icon name="ticket-o" class="section-icon" />
                            票数
                        </div>
                    </div>
                    <div class="ticket-count-grid">
                        <div 
                            v-for="count in ticketCountOptions" 
                            :key="count"
                            class="count-item"
                            :class="{ 'active': selectedTicketCount.includes(count) }"
                            @click="handleTicketCountSelect(count)"
                        >
                            {{ count }}
                        </div>
                    </div>
                </div>

                <div class="filter-section">
                    <div class="section-header">
                        <div class="section-title">
                            <van-icon name="gold-coin-o" class="section-icon" />
                            市场价
                        </div>
                    </div>
                    <div class="price-range">
                        <van-field
                            v-model="priceRange.min"
                            type="number"
                            placeholder="左区间"
                            class="price-input"
                        />
                        <span class="price-separator">-</span>
                        <van-field
                            v-model="priceRange.max"
                            type="number"
                            placeholder="右区间"
                            class="price-input"
                        />
                    </div>
                </div>

                <div class="filter-section">
                    <div class="section-header">
                        <div class="section-title">
                            <van-icon name="location-o" class="section-icon" />
                            调座位
                        </div>
                    </div>
                    <div class="seat-type-grid">
                        <div 
                            v-for="type in ['全部', '允许调座', '不可调座']" 
                            :key="type"
                            class="seat-type-item"
                            :class="{ 'active': selectedSeatType === type }"
                            @click="selectedSeatType = type"
                        >
                            {{ type }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="drawer-footer">
                <van-button plain block @click="resetFilter">重置</van-button>
                <van-button type="primary" block @click="applyFilter">确定</van-button>
            </div>
        </div>
    </van-popup>

    <!-- 遮罩层 -->
    <div v-show="showProvincePopup" class="mask" @click="closeProvincePopup"></div>

    <!-- 省份选择弹出层 -->
    <div v-show="showProvincePopup" class="province-dropdown">
        <div class="province-popup">
            <div class="provinces-grid">
                <div v-for="province in provinces" 
                     :key="province.id" 
                     class="province-item"
                     :class="{ 'active': tempSelectedProvinces.includes(province.id) }"
                     @click="toggleProvince(province.id)">
                    {{ province.name }}
                </div>
            </div>
            <div class="popup-footer">
                <div class="selected-count">已选择<span class="count-number">{{ tempSelectedProvinces.length }}</span>个</div>
                <div class="button-group">
                    <div class="reset-btn" @click="resetProvinces">重置</div>
                    <div class="confirm-btn" @click="confirmProvinces">确认选择</div>
                </div>
            </div>
        </div>
    </div>

    <!-- 城市选择弹出层 -->
    <div v-show="showCityPopup" class="mask" @click="closeCityPopup"></div>
    <div v-show="showCityPopup" class="city-dropdown">
        <div class="city-popup">
            <div class="search-bar">
                <van-search
                    v-model="citySearchKeyword"
                    placeholder="请输入城市名称"
                    @input="filterCities"
                />
            </div>
            <div class="cities-container">
                <div class="cities-grid">
                    <div v-for="city in filteredCities" 
                         :key="city.city_code" 
                         class="city-item"
                         :class="{ 'active': tempSelectedCities.includes(city.city_code) }"
                         @click="toggleCity(city)">
                        {{ city.name }}
                    </div>
                </div>
            </div>
            <div class="popup-footer">
                <div class="selected-count">已选择<span class="count-number">{{ tempSelectedCities.length }}</span>个</div>
                <div class="button-group">
                    <div class="reset-btn" @click="resetCities">重置</div>
                    <div class="confirm-btn" @click="confirmCities">确认选择</div>
                </div>
            </div>
        </div>
    </div>

    <!-- 电影选择弹出层 -->
    <div v-show="showMoviePopup" class="mask" @click="closeMoviePopup"></div>
    <div v-show="showMoviePopup" class="movie-dropdown">
        <div class="movie-popup">
            <div class="movies-container">
                <div class="movies-grid">
                    <div v-for="movie in movies" 
                         :key="movie.ID" 
                         class="movie-item"
                         :class="{ 'active': tempSelectedMovies.includes(movie.ID) }"
                         @click="toggleMovie(movie)">
                        <span class="movie-name">{{ movie.name }}</span>
                    </div>
                </div>
            </div>
            <div class="popup-footer">
                <div class="selected-count">已选择<span class="count-number">{{ tempSelectedMovies.length }}</span>个</div>
                <div class="button-group">
                    <div class="reset-btn" @click="resetMovies">重置</div>
                    <div class="confirm-btn" @click="confirmMovies">确认选择</div>
                </div>
            </div>
        </div>
    </div>

    <!-- 座位选择弹出层 -->
    <div v-show="showSeatPopup" class="mask" @click="closeSeatPopup"></div>
    <div v-show="showSeatPopup" class="province-dropdown">
        <div class="province-popup">
            <div class="provinces-grid">
                <div v-for="seat in seatOptions" 
                     :key="seat.id" 
                     class="province-item"
                     :class="{ 'active': selectedSeat === seat.id }"
                     @click="selectSeat(seat.id)">
                    {{ seat.name }}
                </div>
            </div>
            <div class="popup-footer">
                <div class="button-group" style="width: 100%; justify-content: center;">
                    <div class="confirm-btn" @click="confirmSeat">确认选择</div>
                </div>
            </div>
        </div>
    </div>

    <van-popup
        v-model="showBidDialog"
        position="bottom"
        round
        closeable
        safe-area-inset-bottom
        class="bid-sheet-popup"
    >
        <div class="bid-sheet" v-if="currentBidItem">
            <div class="bid-sheet__header">
                <h3>提交报价</h3>
                <p>{{ currentBidItem.cinema_name }}</p>
            </div>

            <div class="bid-sheet__order">
                <van-image class="bid-sheet__poster" fit="cover" :src="currentBidItem.logo+'_200x200'" />
                <div class="bid-sheet__content">
                    <div class="bid-sheet__movie">{{ currentBidItem.movie_name }}</div>
                    <div class="bid-sheet__meta">
                        <span v-if="currentBidItem.play_date_tag">{{ currentBidItem.play_date_tag }}</span>
                        <span>{{ currentBidItem.play_time_text }}</span>
                        <span v-if="currentBidItem.hall_name">{{ currentBidItem.hall_name }}</span>
                    </div>
                    <div class="bid-sheet__tags">
                        <span>{{ currentBidItem.quantity }}张</span>
                        <span v-if="currentBidItem.support_exchange_seat === 'Y'">可调座</span>
                        <span v-if="currentBidItem.seatTag === '2'">情侣座</span>
                    </div>
                </div>
            </div>

            <div class="bid-sheet__prices">
                <div><span>市场参考价</span><strong>￥{{ currentBidItem.channel_price }}/张</strong></div>
                <div><span>最高报价</span><strong class="is-limit">￥{{ currentBidItem.order_price }}</strong></div>
            </div>

            <label class="bid-sheet__field">
                <span>我的报价</span>
                <div class="bid-sheet__input-wrap">
                    <span>￥</span>
                    <input
                        v-model.trim="bidPrice"
                        type="number"
                        inputmode="decimal"
                        step="0.01"
                        min="0"
                        :max="currentBidItem.order_price"
                        placeholder="请输入金额"
                        @keyup.enter="confirmBid"
                    />
                </div>
            </label>

            <van-button
                block
                type="danger"
                class="bid-sheet__submit"
                :loading="bidSubmitting"
                :disabled="bidSubmitting"
                loading-text="提交中"
                @click="confirmBid"
            >
                确认报价
            </van-button>
        </div>
    </van-popup>
</div>
</template>

<script>
import Api from '@/api-service'

const FILTER_CACHE_KEY = 'ticket_pool_filters';

export default {
    name: "Main.vue",
    data() {
        return {
            tableData: [],
            editData: {},
            refresh: false,
            loading: false,
            isFetching: false,
            loadError: false,
            timer: null,
            price: '',
            select: {
                province_id: [],
                city_code: [],
                cinema_name: '',
                movie_id: [],
                all: true
            },
            showFilter: false,
            showProvincePopup: false,
            showCityPopup: false,
            showMoviePopup: false,
            showSeatPopup: false,
            selectedProvince: '',
            selectedCity: '',
            selectedMovie: '',
            selectedSeatType: '全部',
            provinces: [],
            cities: [],
            movies: [],
            seatTypes: ['全部', '允许调座', '不可调座'],
            cinemaKeyword: '',
            selectedProvinces: [],
            selectedCities: [],
            selectedCinemas: [],
            selectedCinemaTypes: [],
            tempSelectedCinemaTypes: [],
            selectedMovies: [],
            selectedTicketCount: ['不限'],
            cinemaTypes: [],
            filteredCinemas: [],
            searchTimer: null,
            tempSelectedCities: [],
            selectedCityNames: '',
            seatOptions: [
                { id: 0, name: '全部', value: null },
                { id: 1, name: '允许调座', value: 1 },
                { id: 2, name: '不可调座', value: 2 }
            ],
            selectedSeat: 0,
            selectedSeatName: '',
            activeFilter: '',
            tempSelectedProvinces: [],
            selectedProvinceNames: '',
            tempSelectedMovies: [],
            selectedMovieNames: '',
            filterItems: [
                { name: '省份', type: 'province' },
                { name: '城市', type: 'city' },
                { name: '电影', type: 'movie' },
                { name: '调座', type: 'seat' }
            ],
            citySearchKeyword: '',
            filteredCities: [],
            isDrawerProvinceExpanded: false,
            isDrawerCityExpanded: false,
            isDrawerMovieExpanded: false,

            cinemaInputs: [{ value: '' }],
            priceRange: {
                min: '',
                max: ''
            },
            ticketCountOptions: ['不限', '1', '2', '3', '4'],
            showBidDialog: false,
            currentBidItem: null,
            bidPrice: '',
            bidSubmitting: false,
        }
    },
    created() {
        this.initializeData();
        // 创建定时器，每50秒更新一次数据
        this.startTimer();
    },
    mounted() {
        // 定时器已在created中创建，这里不需要重复创建
    },
    beforeDestroy() {
        // 页面销毁前清除定时器
        this.clearTimer();
    },
    beforeRouteLeave(to, from, next) {
        // 路由离开时清除定时器
        this.clearTimer();
        next();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            // 路由进入时开始定时器
            vm.startTimer();
        });
    },
    activated() {
        // 关闭所有弹窗和遮罩，防止遮挡页面
        this.showBidDialog = false;
        this.showFilter = false;
        this.showProvincePopup = false;
        this.showCityPopup = false;
        this.showMoviePopup = false;
        this.showSeatPopup = false;
        this.fetchData({ silent: true });
    },
    methods: {
        // 开始定时器
        startTimer() {
            this.clearTimer(); // 先清除可能存在的定时器
            this.timer = setInterval(() => {
                this.fetchData({ silent: true });
            }, 50000); // 50秒更新一次
        },
        // 清除定时器
        clearTimer() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        onRefresh() {
            this.fetchData();
        },
        fetchData(options = {}) {
            if (this.isFetching) {
                this.refresh = false;
                return;
            }
            const silent = options.silent === true;
            this.isFetching = true;
            this.loadError = false;
            if (!silent) this.loading = true;
            const ticketCount = this.selectedTicketCount.includes('不限') ? null : 
                [...new Set(this.selectedTicketCount)].map(count => parseInt(count));

            const params = {
                page: 1,
                pageSize: 100,
                all: true,
                province_ids: this.selectedProvinces,
                city_codes: this.selectedCities,
                cinema_ids: this.selectedCinemas,
                cinema_types: this.selectedCinemaTypes,
                movie_ids: this.selectedMovies,
                ticket_counts: ticketCount,
                seat_type: this.selectedSeatType === '全部' ? null : this.selectedSeatType === '允许调座' ? 1 : 2,
                min_price: this.priceRange.min || null,
                max_price: this.priceRange.max || null,
                cinema_names: this.getCinemaNames()
            };

            Api.getOrderList(params).then(res => {
                const newList = (res.list || []).map(item => {
                    if (item.order_id in this.editData) {
                        if (this.editData[item.order_id] != '' && this.editData[item.order_id] > 0) {
                            item.bid_price = this.editData[item.order_id];
                        }
                    }
                    // 初始化isFinished属性
                    item.isFinished = item.remaining <= 0;
                    return item;
                });
                this.tableData = newList;
                this.loading = false;
                this.isFetching = false;
                this.refresh = false;
            }).catch(() => {
                this.loading = false;
                this.isFetching = false;
                this.loadError = true;
                this.refresh = false;
            });
        },
        bidOrder(item) {
            return new Promise((resolve, reject) => {
                Api.bidOrder({
                    order_id: item.order_id,
                    bid_price: item.bid_price,
                }).then(res => {
                    console.log(res);
                    this.$toast.success("报价成功");
                    this.fetchData();
                    resolve(true);
                }).catch(error => {
                    console.error('报价失败:', error);
                    this.$toast.fail("报价失败");
                    reject(error);
                });
            });
        },
        unbidOrder(item) {
            Api.unbidOrder({
                order_id: item.order_id,
            }).then(res => {
                this.$toast.success("取消成功");
                this.editData[item.order_id] = ''
                this.fetchData();
            });
        },
        shouldShowCancelButton(item) {
            return item.bid_time !== '0001-01-01T00:00:00Z';
        },
        handleBlur(item) {
            // 当输入框失去焦点时，处理数值
            console.log('handleBlur')
            console.log(item)
            const value = item.bid_price;
            if (value) {
                // 如果输入了值，格式化为一位小数
                // item.bid_price = parseFloat(value).toFixed(1);
                this.editData[item.order_id] = item.bid_price
                console.log('handleBlur')
                console.log(this.editData)
            } else {
                this.editData[item.order_id] = ''
            }
        },
        async initializeData() {
            try {
            // 加载基础数据
                await Promise.all([
                    this.fetchProvinces(),
                    this.fetchCities(),
                    this.fetchCinemaClasses(),
                    this.fetchMovies(),
                    
                ]);

                // 仅从本地缓存恢复筛选条件，不再请求 /filter-config
                this.restoreFromLocalCache();

                // 最后加载订单数据
                this.fetchData();
            } catch (error) {
                console.error('初始化数据失败:', error);
                this.restoreFromLocalCache();
                this.fetchData();
            }
        },
        async fetchProvinces() {
            try {
                const res = await Api.getProvinces();
                this.provinces = res.list || [];
                return res;
            } catch (error) {
                console.error('获取省份数据失败:', error);
                return null;
            }
        },
        async fetchCities() {
            try {
                const res = await Api.getCities();
                this.cities = res.list || [];
                this.filteredCities = [...this.cities];
                return res;
            } catch (error) {
                console.error('获取城市数据失败:', error);
                return null;
            }
        },
        async fetchMovies() {
            try {
                const res = await Api.getMovieList();
                this.movies = res.list || [];
                return res;
            } catch (error) {
                console.error('获取电影数据失败:', error);
                return null;
            }
        },
        async fetchCinemaClasses() {
            try {
                const res = await Api.getCinemaClassSelectList();
                const list = (res && res.list) || (res && res.data && res.data.list) || [];
                this.cinemaTypes = Array.isArray(list) ? list.map(x => ({ id: x.id, name: x.name || x.label || '' })) : [];
                return res;
            } catch (error) {
                console.error('获取影院分类失败:', error);
                this.cinemaTypes = [];
                return null;
            }
        },
        onProvinceConfirm(value) {
            this.selectedProvince = value;
            this.showProvincePopup = false;
            this.fetchData();
        },
        onCityConfirm(value) {
            this.selectedCity = value;
            this.showCityPopup = false;
            this.fetchData();
        },
        onMovieConfirm(value) {
            this.selectedMovie = value;
            this.showMoviePopup = false;
            this.fetchData();
        },
        onSeatTypeConfirm(value) {
            this.selectedSeatType = value;
            this.showSeatPopup = false;
            this.fetchData();
        },
        toggleProvince(id) {
            const index = this.tempSelectedProvinces.indexOf(id);
            if (index > -1) {
                this.tempSelectedProvinces.splice(index, 1);
            } else {
                this.tempSelectedProvinces.push(id);
            }
        },
        toggleCity(city) {
            const index = this.tempSelectedCities.indexOf(city.city_code);
            if (index > -1) {
                this.tempSelectedCities.splice(index, 1);
            } else {
                this.tempSelectedCities.push(city.city_code);
            }
        },
        toggleCinema(id) {
            const index = this.selectedCinemas.indexOf(id);
            if (index > -1) {
                this.selectedCinemas.splice(index, 1);
            } else {
                this.selectedCinemas.push(id);
            }
        },

        toggleMovie(movie) {
            const index = this.tempSelectedMovies.indexOf(movie.ID);
            if (index > -1) {
                this.tempSelectedMovies.splice(index, 1);
            } else {
                this.tempSelectedMovies.push(movie.ID);
            }
        },
        toggleCinemaType(id) {
            const index = this.tempSelectedCinemaTypes.indexOf(id);
            if (index > -1) {
                this.tempSelectedCinemaTypes.splice(index, 1);
            } else {
                this.tempSelectedCinemaTypes.push(id);
            }
        },
        resetFilter() {
            // 清空临时选中状态
            this.tempSelectedProvinces = [];
            this.tempSelectedCities = [];
            this.tempSelectedMovies = [];
            this.tempSelectedCinemaTypes = [];
            this.selectedTicketCount = ['不限'];
            this.selectedSeatType = '全部';
            
            // 清空影院输入
            this.cinemaInputs = [{ value: '' }];
            
            // 清空价格范围
            this.priceRange = {
                min: '',
                max: ''
            };
        },
        applyFilter() {
            // 更新实际选中状态
            this.selectedProvinces = [...this.tempSelectedProvinces];
            this.selectedCities = [...this.tempSelectedCities];
            this.selectedMovies = [...this.tempSelectedMovies];
            this.selectedCinemaTypes = [...this.tempSelectedCinemaTypes];
            
            // 更新显示文本
            this.updateFilterDisplayText();
            
            // 关闭抽屉
            this.showFilter = false;
            
            // 保存配置并刷新数据
            this.saveFilterConfig();
            this.fetchData();
        },
        fetchCinemas() {
            if (this.cinemaKeyword) {
                Api.searchCinemas({
                    keyword: this.cinemaKeyword,
                    province_ids: this.selectedProvinces,
                    city_codes: this.selectedCities
                }).then(res => {
                    this.filteredCinemas = res.list;
                });
            }
        },
        handleCinemaSearch() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.fetchCinemas();
            }, 300);
        },
        handleFilterClick(type, event) {
            if (this.activeFilter === type) {
                // 如果点击的是当前激活的筛选项，则关闭所有弹框
                this.showProvincePopup = false;
                this.showCityPopup = false;
                this.showMoviePopup = false;
                this.showSeatPopup = false;
                this.activeFilter = '';
                return;
            }

            // 设置新的激活状态
            this.activeFilter = type;
            
            // 关闭所有弹框
            this.showProvincePopup = false;
            this.showCityPopup = false;
            this.showMoviePopup = false;
            this.showSeatPopup = false;

            // 打开对应的弹框并初始化临时选中状态
            switch(type) {
                case 'province':
                    this.showProvincePopup = true;
                    this.tempSelectedProvinces = [...this.selectedProvinces];
                    break;
                case 'city':
                    this.showCityPopup = true;
                    this.citySearchKeyword = '';
                    this.tempSelectedCities = [...this.selectedCities];
                    this.filteredCities = [...this.cities];
                    break;
                case 'movie':
                    this.showMoviePopup = true;
                    this.tempSelectedMovies = [...this.selectedMovies];
                    break;
                case 'seat':
                    this.showSeatPopup = true;
                    break;
            }
        },
        closeAllPopups() {
            this.showProvincePopup = false;
            this.showCityPopup = false;
            this.showMoviePopup = false;
            this.showSeatPopup = false;
            this.activeFilter = '';
        },
        closeCityPopup() {
            this.showCityPopup = false;
            this.activeFilter = '';
            this.citySearchKeyword = '';
            this.tempSelectedCities = [...this.selectedCities];
        },
        closeMoviePopup() {
            this.showMoviePopup = false;
            this.activeFilter = '';
        },
        closeSeatPopup() {
            this.showSeatPopup = false;
            this.activeFilter = '';
        },
        resetProvinces() {
            this.tempSelectedProvinces = [];
        },
        async confirmProvinces() {
            this.selectedProvinces = [...this.tempSelectedProvinces];
            const selectedNames = this.provinces
                .filter(p => this.selectedProvinces.includes(p.id))
                .map(p => p.name);
            
            this.selectedProvinceNames = selectedNames.length > 0 
                ? (selectedNames.length > 2 
                    ? `${selectedNames[0]},${selectedNames[1]}...` 
                    : selectedNames.join(','))
                : '';
            
            this.showProvincePopup = false;
            this.activeFilter = '';

            // 保存配置到本地和服务器
            await this.saveFilterConfig();
            
            this.fetchData();
        },
        closeProvincePopup() {
            this.showProvincePopup = false;
            this.activeFilter = '';
        },
        resetCities() {
            this.tempSelectedCities = [];
            this.citySearchKeyword = '';
            this.filteredCities = [...this.cities];
            this.selectedCityNames = '';
        },
        async confirmCities() {
            this.selectedCities = [...this.tempSelectedCities];
            const selectedNames = this.cities
                .filter(city => this.selectedCities.includes(city.city_code))
                .map(city => city.name);
            
            this.selectedCityNames = selectedNames.length > 0 
                ? (selectedNames.length > 2 
                    ? `${selectedNames[0]},${selectedNames[1]}...` 
                    : selectedNames.join(','))
                : '';
            
            this.showCityPopup = false;
            this.activeFilter = '';
            this.citySearchKeyword = '';

            // 保存配置到本地和服务器
            await this.saveFilterConfig();
            
            this.fetchData();
        },
        selectSeat(id) {
            const option = this.seatOptions.find(opt => opt.id === id);
            if (option) {
                this.selectedSeat = id;
                this.selectedSeatType = option.name;
                this.selectedSeatName = option.name;
            }
        },
        async confirmSeat() {
            if (this.selectedSeat !== null) {
                const selectedOption = this.seatOptions.find(s => s.id === this.selectedSeat);
                if (selectedOption) {
                    this.selectedSeatType = selectedOption.name;
                }
            }
            this.showSeatPopup = false;
            this.activeFilter = '';

            // 保存配置到本地和服务器
            await this.saveFilterConfig();
            
            this.fetchData();
        },
        resetMovies() {
            this.tempSelectedMovies = [];
        },
        async confirmMovies() {
            this.selectedMovies = [...this.tempSelectedMovies];
            const selectedNames = this.movies
                .filter(m => this.selectedMovies.includes(m.ID))
                .map(m => m.name);
            
            this.selectedMovieNames = selectedNames.length > 0 
                ? (selectedNames.length > 2 
                    ? `${selectedNames[0]},${selectedNames[1]}...` 
                    : selectedNames.join(','))
                : '';
            
            this.showMoviePopup = false;
            this.activeFilter = '';

            // 保存配置到本地和服务器
            await this.saveFilterConfig();
            
            this.fetchData();
        },
        hasSelectedItems(type) {
            switch(type) {
                case 'province': return !!this.selectedProvinceNames;
                case 'city': return !!this.selectedCityNames;
                case 'movie': return !!this.selectedMovieNames;
                case 'seat': return !!this.selectedSeatName;
                default: return false;
            }
        },
        getSelectedText(type) {
            switch(type) {
                case 'province': return this.selectedProvinceNames;
                case 'city': return this.selectedCityNames;
                case 'movie': return this.selectedMovieNames;
                case 'seat': return this.selectedSeatName;
                default: return '';
            }
        },
        filterCities() {
            if (!this.citySearchKeyword) {
                this.filteredCities = [...this.cities];
                return;
            }
            this.filteredCities = this.cities.filter(city => 
                city.name.toLowerCase().includes(this.citySearchKeyword.toLowerCase()) ||
                (city.pin_yin && city.pin_yin.toLowerCase().includes(this.citySearchKeyword.toLowerCase()))
            );
        },
        isSelectedCity(code) {
            return this.tempSelectedCities.includes(code);
        },
        toggleDrawerProvinceExpand() {
            this.isDrawerProvinceExpanded = !this.isDrawerProvinceExpanded;
        },
        toggleDrawerCityExpand() {
            this.isDrawerCityExpanded = !this.isDrawerCityExpanded;
        },
        toggleDrawerMovieExpand() {
            this.isDrawerMovieExpanded = !this.isDrawerMovieExpanded;
        },

        addCinemaInput() {
            this.cinemaInputs.push({ value: '' });
        },
        removeCinemaInput(index) {
            this.cinemaInputs.splice(index, 1);
        },
        // 当需要获取所有影院名称时使用
        getCinemaNames() {
            return this.cinemaInputs
                .map(input => input.value.trim())
                .filter(value => value !== '');
        },
        // 更新本地缓存
        updateLocalFilterCache(filterConfig) {
            try {
                if (filterConfig) {
                    localStorage.setItem(FILTER_CACHE_KEY, JSON.stringify(filterConfig));
                    console.log('更新本地缓存成功:', filterConfig);
                }
            } catch (error) {
                console.error('保存本地缓存失败:', error);
            }
        },
        // 从本地缓存恢复
        restoreFromLocalCache() {
            try {
                const cachedConfig = localStorage.getItem(FILTER_CACHE_KEY);
                if (cachedConfig) {
                    const config = JSON.parse(cachedConfig);
                    this.applyFilterConfig(config);
                    console.log('已从本地缓存恢复配置:', config);
                }
            } catch (error) {
                console.error('恢复本地缓存失败:', error);
            }
        },
        // 应用筛选配置
        applyFilterConfig(config) {
            if (!config) return;
            
            // 应用各项筛选配置
            this.selectedProvinces = config.provinces || [];
            this.selectedCities = config.cities || [];
            this.selectedMovies = config.movies || [];
            this.selectedCinemaTypes = config.cinemaTypes || [];
            this.selectedTicketCount = config.ticketCount || ['不限'];
            this.selectedSeatType = config.seatType || '全部';
            this.priceRange = config.priceRange || { min: '', max: '' };

            // 同步临时选中状态
            this.tempSelectedProvinces = [...this.selectedProvinces];
            this.tempSelectedCities = [...this.selectedCities];
            this.tempSelectedMovies = [...this.selectedMovies];
            
            // 如果有影院输入，恢复影院输入
            if (config.cinemaInputs && config.cinemaInputs.length > 0) {
                this.cinemaInputs = config.cinemaInputs.map(name => ({ value: name }));
            } else {
                this.cinemaInputs = [{ value: '' }];
            }
            
            // 更新显示文本
            this.updateFilterDisplayText();
        },
        // 更新筛选显示文本
        updateFilterDisplayText() {
            // 确保provinces数据已加载
            if (this.provinces.length > 0) {
                const selectedProvinceNames = this.provinces
                    .filter(p => this.selectedProvinces.includes(p.id))
                    .map(p => p.name);
                
                this.selectedProvinceNames = selectedProvinceNames.length > 0 
                    ? (selectedProvinceNames.length > 2 
                        ? `${selectedProvinceNames[0]},${selectedProvinceNames[1]}...` 
                        : selectedProvinceNames.join(','))
                    : '';
            }

            // 确保cities数据已加载
            if (this.cities.length > 0) {
                const selectedCityNames = this.cities
                    .filter(city => this.selectedCities.includes(city.city_code))
                    .map(city => city.name);
                
                this.selectedCityNames = selectedCityNames.length > 0 
                    ? (selectedCityNames.length > 2 
                        ? `${selectedCityNames[0]},${selectedCityNames[1]}...` 
                        : selectedCityNames.join(','))
                    : '';
            }

            // 确保movies数据已加载
            if (this.movies.length > 0) {
                const selectedMovieNames = this.movies
                    .filter(m => this.selectedMovies.includes(m.ID))
                    .map(m => m.name);
                
                this.selectedMovieNames = selectedMovieNames.length > 0 
                    ? (selectedMovieNames.length > 2 
                        ? `${selectedMovieNames[0]},${selectedMovieNames[1]}...` 
                        : selectedMovieNames.join(','))
                    : '';
            }
        },
        // 获取当前筛选配置
        getCurrentFilterConfig() {
            const ticketCount = this.selectedTicketCount.includes('不限') ? null : 
                [...new Set(this.selectedTicketCount)].map(count => parseInt(count));

            const config = {
                provinces: this.selectedProvinces,
                cities: this.selectedCities,
                movies: this.selectedMovies,
                cinemaTypes: this.selectedCinemaTypes,
                ticketCount: ticketCount,
                seatType: this.selectedSeatType,
                priceRange: this.priceRange,
                cinemaInputs: this.getCinemaNames()
            };
            
            console.log('保存的筛选配置：', config);
            return config;
        },
        // 筛选条件仅缓存在本地，不请求 /filter-config
        saveFilterConfig() {
            const config = this.getCurrentFilterConfig();
            this.updateLocalFilterCache(config);
        },
        handleTicketCountSelect(count) {
            if (count === '不限') {
                // 如果选择"不限"，清空其他选择
                this.selectedTicketCount = ['不限'];
            } else {
                // 如果选择具体数字
                // 先移除"不限"选项
                this.selectedTicketCount = this.selectedTicketCount.filter(item => item !== '不限');
                
                const index = this.selectedTicketCount.indexOf(count);
                if (index > -1) {
                    // 如果已经选中，则取消选中
                    this.selectedTicketCount.splice(index, 1);
                    // 如果取消选中后没有选中任何数字，则默认选中"不限"
                    if (this.selectedTicketCount.length === 0) {
                        this.selectedTicketCount = ['不限'];
                    }
                } else {
                    // 如果未选中，则添加到选中列表，并去重
                    if (!this.selectedTicketCount.includes(count)) {
                        this.selectedTicketCount.push(count);
                        // 对数字进行排序
                        this.selectedTicketCount.sort();
                    }
                }
            }
            console.log('当前选中的票数：', this.selectedTicketCount);
        },
        openBidDialog(item) {
            this.currentBidItem = item;
            this.bidPrice = '';
            this.bidSubmitting = false;
            this.showBidDialog = true;
        },
        closeBidDialog() {
            this.showBidDialog = false;
        },
        async confirmBid() {
            if (this.bidSubmitting || !this.currentBidItem) return;
            const price = Number(this.bidPrice);
            const limit = Number(this.currentBidItem.order_price);
            if (!Number.isFinite(price) || price <= 0) {
                this.$toast('请输入有效报价');
                return;
            }
            if (!/^\d+(\.\d{1,2})?$/.test(String(this.bidPrice))) {
                this.$toast('报价最多保留两位小数');
                return;
            }
            if (Number.isFinite(limit) && limit > 0 && price > limit) {
                this.$toast(`报价不能超过￥${limit}`);
                return;
            }
            this.bidSubmitting = true;
            try {
                const res = await this.bidOrder({
                    order_id: this.currentBidItem.order_id,
                    bid_price: price,
                });
                // 报价成功才关闭弹框
                if (res) {
                    this.showBidDialog = false;
                }
            } catch (error) {
                console.error('报价失败:', error);
            } finally {
                this.bidSubmitting = false;
            }
        },
        copyOrderId(orderId) {
            if (!orderId) return;
            if (navigator && navigator.clipboard) {
                navigator.clipboard.writeText(orderId).then(() => {
                    this.$toast('复制成功');
                });
            } else {
                // 兼容性处理
                const input = document.createElement('input');
                input.value = orderId;
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                this.$toast('复制成功');
            }
        },

        goToOrderDetail(item) {
            this.$router.push({ name: 'BidOrderDetail', params: { orderId: item.order_id }, query: { order: encodeURIComponent(JSON.stringify(item)) } });
        },
        handleCardClick(item, event) {
            // 如果点击的是报价按钮则不跳转
            const btn = event.target.closest('.bid-btn-strict');
            if (btn) return;
            
            // 如果倒计时结束，不允许跳转到订单详情页
            if (item.isFinished) {
                this.$toast('订单已结束，无法查看详情');
                return;
            }
            
            // 倒计时未结束时，可以跳转到详情页进行报价
            this.goToOrderDetail(item);
        },
    },
    watch: {
        cities: {
            immediate: true,
            handler(val) {
                this.filteredCities = [...val];
            }
        },
        showFilter(val) {
            if (val) {
                this.tempSelectedProvinces = [...this.selectedProvinces];
                this.tempSelectedCities = [...this.selectedCities];
                this.tempSelectedMovies = [...this.selectedMovies];
                this.tempSelectedCinemaTypes = [...this.selectedCinemaTypes];
            }
        },
        showCityPopup(val) {
            if (val) {
                // 打开弹框时，初始化搜索关键词和过滤后的城市列表
                this.citySearchKeyword = '';
                this.filteredCities = [...this.cities];
                this.tempSelectedCities = [...this.selectedCities]; // 初始化临时选中数组
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.home-wrap {
    height: auto;
    min-height: 100vh;
    min-height: 100dvh;
    background-color: #f3f3f3;
    padding-top: 57px;
    padding-bottom: calc(50px + env(safe-area-inset-bottom, 0px));

    .main-card-wrap {
        margin: 10px 10px;
        padding: 16px;
        border-radius: 6px;
        background-color: white;
        -moz-box-shadow: 2px 2px 3px #ccc;
        -webkit-box-shadow: 2px 2px 3px #ccc;
        box-shadow: 2px 2px 3px #ccc;

        .left {
            .title {
                font-size: 18px;
            }

            .subtitle {
                font-size: 14px;
                margin-top: 6px;
            }

            .priceTitle {
                font-size: 16px;
                color: #c75450;

            }

            .otherTitle {
                font-size: 14px;
                margin-top: 6px;
                color: #999;
            }

            .btn {
                height: 34px;
                width: 120px;
                color: white;
                margin-top: 6px;
                border-radius: 4px;
                background-color: #8565bd;
            }
        }

        .right {
            margin-right: 8px
        }
    }
}

::v-deep .van-field__control {
    border-bottom: 1px solid #ccc;
    /* 定义下划线样式 */
}

.time_right {
    display: flex;
    justify-content: flex-end;
    /* 使子元素靠右显示 */
    align-items: center;
    /* 垂直居中 */
}
/* 自定义 van-count-down 的样式 */
::v-deep .van-count-down {
    color: red;
    font-weight: bold;
}

.filter-bar {
    position: fixed;
    top: 46px;
    left: 0;
    right: 0;
    z-index: 100;
    background: #fff;
    border-bottom: 1px solid #eee;

    .filter-scroll {
        display: flex;
        gap: 6px;
        padding: 8px 10px;
    }

    .filter-item {
        flex: 1 1 0;
        min-width: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 6px;
        border: 1px solid #eee;
        border-radius: 4px;
        box-sizing: border-box;
        
        .filter-text {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            margin-right: 3px;
            text-align: center;
        }

        .van-icon {
            flex-shrink: 0;
            font-size: 12px;
        }
    }
}

.filter-drawer {
    height: 100%;
    display: flex;
    flex-direction: column;

    .drawer-header {
        padding: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #eee;
    }

    .drawer-content {
        flex: 1;
        overflow-y: auto;
        padding: 15px;

        .filter-section {
            margin-bottom: 20px;

            .section-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;

                .section-title {
                    font-weight: bold;
                    font-size: 15px;
                    color: #333;
                }

                .section-expand {
                    color: #666;
                    font-size: 13px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;

                    span {
                        margin-right: 3px;
                    }

                    .van-icon {
                        font-size: 12px;
                    }
                }
            }

            // 恢复原有的网格布局样式
            .drawer-province-grid,
            .drawer-city-grid,
            .drawer-movie-grid,
            .drawer-cinema-type-grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 10px;
                transition: max-height 0.3s ease;

                &.collapsed {
                    max-height: 90px;
                    overflow: hidden;
                }

                .province-item,
                .city-item,
                .movie-item,
                .cinema-type-item {
                    text-align: center;
                    padding: 8px 4px;
                    font-size: 12px;
                    background: #f7f8fa;
                    border: 1px solid #f7f8fa;
                    color: #666;
                    border-radius: 20px;
                    cursor: pointer;
                    user-select: none;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    position: relative;
                    z-index: 1;
                    min-height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &.active {
                        background: #fff;
                        color: #ff2c54;
                        border: 1px solid #ff2c54;
                    }

                    &:active {
                        opacity: 0.8;
                        transform: scale(0.98);
                    }

                    &:hover {
                        background: #e8e8e8;
                    }

                    &.disabled {
                        cursor: not-allowed;
                        opacity: 0.5;
                        background: #f0f0f0;
                        color: #999;
                        border: 1px solid #e0e0e0;

                        &:hover {
                            background: #f0f0f0;
                        }

                        &:active {
                            opacity: 0.5;
                            transform: none;
                        }
                    }
                }
            }

            // 恢复影院输入框样式
            .cinema-inputs-grid {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 10px;

                .cinema-input-item {
                    .cinema-field {
                        :deep(.van-field__control) {
                            border-bottom: none;
                        }
                    }
                }
            }

            // 新增部分的样式
            &.custom-section {
                padding: 0 12px;
                margin-bottom: 24px;

                .section-header {
                    margin-bottom: 12px;

                    .section-title {
                        display: flex;
                        align-items: center;

                        .section-icon {
                            margin-right: 6px;
                            font-size: 16px;
                            color: #666;
                        }

                        .feature-disabled {
                            margin-left: 8px;
                            font-size: 12px;
                            color: #999;
                            font-weight: normal;
                        }
                    }
                }
            }

            .ticket-count-grid {
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                gap: 8px;
                padding: 8px 0;

                .count-item {
                    text-align: center;
                    padding: 8px 0;
                    font-size: 14px;
                    background: #f7f8fa;
                    border: 1px solid #f7f8fa;
                    color: #666;
                    border-radius: 4px;
                    cursor: pointer;
                    user-select: none;
                    transition: all 0.3s ease;

                    &.active {
                        background: #fff;
                        color: #ff2c54;
                        border: 1px solid #ff2c54;
                    }

                    &:hover {
                        opacity: 0.8;
                    }

                    &:active {
                        transform: scale(0.98);
                    }
                }
            }

            .price-range {
                display: flex;
                align-items: center;
                gap: 10px;

                .price-input {
                    flex: 1;
                    background: #f7f8fa;
                    border-radius: 20px;
                    height: 36px;

                    :deep(.van-field__body) {
                        background: #f7f8fa;
                    }

                    :deep(.van-field__control) {
                        text-align: center;
                        font-size: 14px;
                        color: #666;

                        &::placeholder {
                            color: #999;
                            font-size: 12px;
                        }
                    }
                }

                .price-separator {
                    color: #666;
                    font-size: 16px;
                    font-weight: bold;
                }
            }

            .seat-type-grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 12px;

                .seat-type-item {
                    text-align: center;
                    padding: 8px 4px;
                    font-size: 14px;
                    background: #f7f8fa;
                    border: 1px solid #f7f8fa;
                    color: #666;
                    border-radius: 20px;
                    cursor: pointer;
                    user-select: none;

                    &.active {
                        background: #fff;
                        color: #ff2c54;
                        border: 1px solid #ff2c54;
                    }

                    &:active {
                        opacity: 0.8;
                    }
                }
            }
        }
    }

    .drawer-footer {
        padding: 12px 15px calc(12px + env(safe-area-inset-bottom, 0px));
        border-top: 1px solid #eee;
        display: flex;
        gap: 10px;

        .van-button {
            flex: 1;
            height: 44px;
            border-radius: 20px;
            font-size: 14px;

            &--default {
                border: 1px solid #ff2c54;
                color: #ff2c54;
            }

            &--primary {
                background: #ff2c54;
                border: none;
            }
        }
    }
}

.filter-dropdown {
    position: fixed;
    top: 90px;
    left: 0;
    right: 0;
    z-index: 2001;
}

.filter-popup {
    background: #fff;
    padding: 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .grid-layout {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;
        padding: 0 8px;
        margin-bottom: 15px;

        .grid-item {
            text-align: center;
            padding: 10px;
            background: #f8f8f8;
            border-radius: 4px;
            font-size: 14px;
            user-select: none;

            &.active {
                background: #fff2f4;
                color: #ff2c54;
            }

            &:active {
                opacity: 0.8;
            }
        }
    }
}

.mask {
    position: fixed;
    top: 90px; // 从筛选栏下方开始
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 2000;
}

.province-dropdown {
    position: fixed;
    top: 90px;
    left: 0;
    right: 0;
    z-index: 2001;
}

.province-popup {
    background: #fff;
    padding: 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .provinces-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;
        padding: 0 8px;
        margin-bottom: 15px;

        .province-item {
            text-align: center;
            padding: 10px;
            background: #f8f8f8;
            border-radius: 4px;
            font-size: 14px;
            user-select: none;

            &.active {
                background: #fff2f4;
                color: #ff2c54;
            }

            &:active {
                opacity: 0.8;
            }
        }
    }

    .popup-footer {
        padding-top: 15px;
        border-top: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .selected-count {
            color: #666;
            font-size: 14px;

            .count-number {
                color: #ff2c54;
                font-weight: bold;
                margin: 0 2px;
            }
        }

        .button-group {
            display: flex;
            gap: 15px;

            .reset-btn, .confirm-btn {
                padding: 6px 16px;
                border-radius: 20px;
                font-size: 14px;
                cursor: pointer;
            }

            .reset-btn {
                border: 1px solid #ddd;
                color: #666;
            }

            .confirm-btn {
                background: #ff2c54;
                color: #fff;
            }
        }
    }
}

.filter-item {
    span {
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.city-dropdown {
    position: fixed;
    top: 90px;
    left: 0;
    right: 0;
    z-index: 2001;
}

.city-popup {
    background: #fff;
    padding: 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .search-bar {
        margin: -15px -15px 0;
        
        .van-search {
            padding: 8px 12px;
            background: #fff;
        }
    }

    .cities-container {
        max-height: 60vh;
        overflow-y: auto;
        margin: 10px -8px;
        padding: 0 8px;
        
        &::-webkit-scrollbar {
            width: 4px;
        }
        
        &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 2px;
        }
    }

    .cities-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;

        .city-item {
            text-align: center;
            padding: 10px;
            background: #f8f8f8;
            border-radius: 4px;
            font-size: 14px;
            user-select: none;

            &.active {
                background: #fff2f4;
                color: #ff2c54;
            }

            &:active {
                opacity: 0.8;
            }
        }
    }

    .popup-footer {
        padding-top: 15px;
        border-top: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .selected-count {
            color: #666;
            font-size: 14px;

            .count-number {
                color: #ff2c54;
                font-weight: bold;
                margin: 0 2px;
            }
        }

        .button-group {
            display: flex;
            gap: 15px;

            .reset-btn, .confirm-btn {
                padding: 6px 16px;
                border-radius: 20px;
                font-size: 14px;
                cursor: pointer;
            }

            .reset-btn {
                border: 1px solid #ddd;
                color: #666;
            }

            .confirm-btn {
                background: #ff2c54;
                color: #fff;
            }
        }
    }
}

.movie-dropdown {
    position: fixed;
    top: 90px;
    left: 0;
    right: 0;
    z-index: 2001;
}

.movie-popup {
    background: #fff;
    padding: 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .movies-container {
        max-height: 70vh;
        overflow-y: auto;
        
        &::-webkit-scrollbar {
            width: 4px;
        }
        
        &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 2px;
        }
    }

    .movies-grid {
        display: grid;
        grid-template-columns: repeat(4, calc(25% - 9px));
        gap: 12px;
        padding-bottom: 15px;

        .movie-item {
            text-align: center;
            padding: 10px 5px;
            background: #f8f8f8;
            border-radius: 4px;
            cursor: pointer;
            user-select: none;
            min-width: 0;

            &.active {
                background: #fff2f4;
                color: #ff2c54;
            }

            &:active {
                opacity: 0.8;
            }

            .movie-name {
                display: block;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                line-height: 1.2;
                padding: 0 2px;
            }
        }
    }

    .popup-footer {
        padding-top: 15px;
        border-top: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .selected-count {
            color: #666;
            font-size: 14px;

            .count-number {
                color: #ff2c54;
                font-weight: bold;
                margin: 0 2px;
            }
        }

        .button-group {
            display: flex;
            gap: 15px;

            .reset-btn, .confirm-btn {
                padding: 6px 16px;
                border-radius: 20px;
                font-size: 14px;
                cursor: pointer;
            }

            .reset-btn {
                border: 1px solid #ddd;
                color: #666;
            }

            .confirm-btn {
                background: #ff2c54;
                color: #fff;
            }
        }
    }
}

.drawer-movie-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    transition: max-height 0.3s ease;

    &.collapsed {
        max-height: 90px;
        overflow: hidden;
    }

    .movie-item {
        text-align: center;
        padding: 8px 4px;
        font-size: 14px;
        background: #f7f8fa;
        border: 1px solid #f7f8fa;
        color: #666;
        border-radius: 20px;
        cursor: pointer;
        user-select: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &.active {
            background: #fff;
            color: #ff2c54;
            border: 1px solid #ff2c54;
        }

        &:active {
            opacity: 0.8;
        }
    }
}

.order-card-outer {
    margin: 12px;
}
.order-card-strict {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    padding: 13px 12px;
    display: flex;
    flex-direction: column;
    font-family: inherit;
    min-height: 0;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(0,0,0,0.1);
    }

    &.expired {
        background: #f8f8f8;
        border: 1px solid #e0e0e0;
        cursor: not-allowed;
        opacity: 0.7;
        position: relative;

        &::after {
            content: '订单已结束';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgba(153, 153, 153, 0.9);
            color: white;
            padding: 8px 16px;
            border-radius: 20px;
            font-size: 14px;
            font-weight: bold;
            opacity: 0;
            transition: opacity 0.3s ease;
            pointer-events: none;
            z-index: 10;
        }

        &:hover::after {
            opacity: 1;
        }
    }
}
.order-card-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 2px;
    flex-shrink: 0;
    gap: 8px;
}
.top-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
}
.cinema-name {
    font-size: 16px;
    font-weight: bold;
    color: #222;
    line-height: 1.2;
    margin-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.hall-name {
    font-size: 13px;
    color: #888;
    line-height: 1.2;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.top-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    height: 100%;
    min-width: 90px;
    margin-left: 8px;
    flex-shrink: 0;
}
.market-price {
    font-size: 13px;
    // font-weight: bold;
    margin-bottom: 2px;
    color: #888;
    white-space: nowrap;
    text-align: right;
}
.market-price-num {
    color: #ff2c54;
    font-weight: bold;
    margin-left: 2px;
}
.max-price {
    font-size: 13px;
    color: #888;
    white-space: nowrap;
    text-align: right;
}
.order-card-bottom {
    display: grid;
    grid-template-columns: 1fr auto;
    min-height: 104px;
    margin-top: 4px;
    gap: 0 10px;
}
.bottom-left {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    flex: 1;
}
.movie-img-box {
    flex-shrink: 0;
    margin-right: 10px;
    height: 100%;
    display: flex;
    align-items: stretch;
}
.movie-img-box .van-image {
    width: 80px !important;
    height: 100% !important;
}
.movie-info-box {
    flex: 1;
    min-width: 0;
}
.movie-title {
    font-size: 15px;
    font-weight: 500;
    color: #333;
    margin-bottom: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.movie-tags {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    gap: 6px;
}
.ticket-count {
    background: #f7f8fa;
    border-radius: 8px;
    font-size: 10px;
    padding: 1px 1px;
}
.seat-type-tag {
    border: 2px solid rgb(0, 140, 255);
    color: rgb(0, 140, 255);
    border-radius: 2px;
    font-size: 10px;
    font-weight: bold;
    padding: 2px 2px;
}

.couple-seat {
    border: 2px solid #ff2c54;
    color: #ff2c54;
    background-color: #fff2f0;
}
.showtime-row {
    font-size: 13px;
    color: #333;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
}
.today-tag {
    display: inline-block;
    color: white;
    background-color: #ff2c53da;
    font-size: 12px;
    font-weight: bold;
    padding: 2px 6px 2px 4px;
    margin-right: 2px;
    line-height: 1.2;
    vertical-align: middle;
    border-radius: 2px;
    clip-path: polygon(
        0 0,
        calc(100% - 8px) 0,
        100% 50%,
        calc(100% - 8px) 100%,
        0 100%
    );
}
.showtime {
    color: #333;
}
.bidder-row {
    font-size: 12px;
    color: #888;
    margin-bottom: 4px;
}
.bidder-row .bidder-count {
    font-weight: bolder;
    color: #ff2c54;
}
.order-card-bottom > .bottom-right {
    display: flex;
    min-width: 62px;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}
.bottom-right .city-name {
    font-size: 13px;
    color: #333;
    margin-bottom: 6px;
    text-align: center;
}
.bottom-right .bid-btn-strict {
    width: 62px;
    height: 44px;
    border-radius: 9px;
    font-size: 12px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0;
}
.order-card-divider {
    height: 1px;
    background: #eee;
    margin: 2px 0 8px 0;
    width: 100%;
}

.bid-dialog-center {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.18);
    padding: 0;
    .dialog-section {
        padding: 10px 20px 0 20px;
        &:last-child { padding-bottom: 10px; }
    }
    .section-top {
        padding-top: 20px;
        .cinema-title {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 6px;
            color: #222;
        }
        .order-row {
            display: flex;
            align-items: center;
            // justify-content: space-between;
            margin-bottom: 2px;
            .order-id {
                font-size: 13px;
                color: #888;
            }
            .copy-text-btn,
            .copy-text-btn:hover,
            .copy-text-btn:active,
            .copy-text-btn:focus {
              color: #2196f3 !important;
              font-size: 13px;
              margin-left: 12px;
              cursor: pointer;
              user-select: none;
              transition: none;
            }
        }
    }
    .section-movie {
        .movie-info-row {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 15px;
            font-weight: 500;
            margin-bottom: 4px;
            .movie-title { color: #333; }
            .ticket-count { color: #030303; font-weight: bold; }
            .seat-type-tag { background: #eaf6ff; color: #2196f3; border-radius: 4px; padding: 2px 6px; font-size: 12px; }
            .couple-seat { background: #fff2f0 !important; color: #ff2c54 !important; border: 2px solid #ff2c54 !important; }
        }
        .address-row {
            display: flex;
            align-items: center;
            font-size: 13px;
            color: #888;
            margin-top: 18px;
            .address-icon {
                font-size: 16px;
                color: #ff2c54;
                margin-right: 4px;
                flex-shrink: 0;
            }
        }
    }
    .section-price {
        .price-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            // margin-bottom: 2px;
            .price-value { font-weight: bold; }
            .price-limit { color: #ff2c54; }
        }
    }
    .section-action {
        padding: 4px 20px 4px 20px;
        .action-row {
            display: flex;
            align-items: center;
            /* gap: 10px; */
            margin-top: 8px;
        }
        .score-btn {
            flex: 0 0 80px;
            height: 44px;
            background: #fff !important;
            border: 1.5px solid #ff2c54 !important;
            color: #ff2c54 !important;
            box-shadow: none;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding: 4px 6px;
            .score-btn-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 100%;
            }
            .score-label {
                font-size: 13px;
                color: #ff2c54 !important;
                line-height: 1.2;
            }
            .score-action {
                font-size: 13px;
                color: #ff2c54 !important;
                line-height: 1.2;
                margin-top: 2px;
            }

            &.disabled {
                background: #f5f5f5 !important;
                border: 1.5px solid #ccc !important;
                color: #999 !important;
                cursor: not-allowed;

                .score-label {
                    color: #999 !important;
                }
                .score-action {
                    color: #999 !important;
                }
            }
        }
        .bid-input-group {
            flex: 1;
            max-width: 240px;
            min-width: 0;
            display: flex;
            align-items: center;
            margin-left: 10px;
        }
        .bid-input-box {
            display: flex;
            align-items: center;
            width: 100%;
            border: 1.5px solid #ff2c54;
            border-radius: 2px;
            background: #fff;
            height: 44px;
            box-sizing: border-box;
            padding: 0 0 0 8px;
        }
        .rmb-label {
            color: #ff2c54;
            font-size: 15px;
            margin-right: 2px;
            flex-shrink: 0;
        }
        .bid-input {
            border: none;
            background: transparent;
            outline: none;
            font-size: 14px;
            color: #ff2c54;
            flex: 1;
            min-width: 0;
            padding: 0 6px;
            height: 42px;
            &::placeholder {
                color: #ccc;
                font-size: 12px;
            }
        }
        .bid-confirm-btn {
            border: none;
            background: #ff2c54;
            color: #fff;
            font-size: 15px;
            font-weight: bold;
            border-radius: 0 2px 2px 0;
            height: 44px;
            padding: 0 18px;
            cursor: pointer;
            flex-shrink: 0;
            margin-left: 4px;
            transition: background 0.2s;
        }
        .bid-confirm-btn:active,
        .bid-confirm-btn:hover {
            background: #d81b3a;
        }
    }
}
.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 10;
  cursor: pointer;
  color: #bbb;
  transition: color 0.2s;
}
.close-btn:hover {
  color: #ff2c54;
}

.movie-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
//   margin-bottom: 4px;
  width: 100%;
  .city-name {
    font-size: 15px;
    color: #333;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .movie-title {
    font-weight: 500;
    flex: 1 1 auto;
  }
  .city-name {
    margin-left: 12px;
    flex: none;
    min-width: 60px;
    text-align: right;
  }
}

.movie-title-row .movie-title {
  margin-bottom: 0 !important;
}

.movie-info-box > * {
  margin-bottom: 10px;
}
.movie-info-box > *:last-child {
  margin-bottom: 0;
}

.dialog-gradient-bg {
  background: linear-gradient(to right, #e6f9f0 0%, #d2fbe7 100%);
  border-radius: 16px 16px 0 0;
  padding: 0;
}

.score-btn {
  flex: 0 0 110px;
  height: 44px;
  background: #fff !important;
  border: 1.5px solid #ff2c54 !important;
  color: #ff2c54 !important;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 4px 6px;
  .score-btn-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  .score-label {
    font-size: 13px;
    color: #ff2c54 !important;
    line-height: 1.2;
  }
  .score-action {
    font-size: 13px;
    color: #ff2c54 !important;
    line-height: 1.2;
    margin-top: 2px;
  }

  &.disabled {
    background: #f5f5f5 !important;
    border: 1.5px solid #ccc !important;
    color: #999 !important;
    cursor: not-allowed;

    .score-label {
      color: #999 !important;
    }
    .score-action {
      color: #999 !important;
    }
  }
}

.rmb-symbol {
  color: #ff2c54;
  font-size: 15px;
  font-weight: bold;
//   margin-right: 5px;
// margin-left: 2px;
  flex-shrink: 0;
}

::v-deep .bid-sheet-popup {
  width: 100%;
  max-height: 88vh;
  overflow-y: auto;
}

.bid-sheet {
  padding: 22px 18px calc(18px + env(safe-area-inset-bottom, 0px));
}

.bid-sheet__header {
  padding-right: 34px;

  h3 {
    margin: 0;
    color: #1d2735;
    font-size: 19px;
    line-height: 1.4;
  }

  p {
    margin: 4px 0 0;
    overflow: hidden;
    color: #657284;
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.bid-sheet__order {
  display: flex;
  gap: 12px;
  margin-top: 18px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8ecf2;
}

.bid-sheet__poster {
  width: 66px;
  height: 88px;
  flex: none;
  overflow: hidden;
  border-radius: 8px;
  background: #f4f6f9;
}

.bid-sheet__content {
  min-width: 0;
  flex: 1;
}

.bid-sheet__movie {
  overflow: hidden;
  color: #1d2735;
  font-size: 16px;
  font-weight: 650;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bid-sheet__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 5px 8px;
  margin-top: 8px;
  color: #536171;
  font-size: 13px;
  line-height: 1.4;
}

.bid-sheet__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;

  span {
    padding: 3px 7px;
    border-radius: 6px;
    background: #f1f3f7;
    color: #536171;
    font-size: 11px;
  }
}

.bid-sheet__prices {
  margin-top: 6px;

  div {
    display: flex;
    min-height: 40px;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    color: #657284;
    font-size: 14px;
  }

  strong {
    color: #1d2735;
    font-weight: 600;
  }

  .is-limit {
    color: #e5484d;
  }
}

.bid-sheet__field {
  display: block;
  margin-top: 10px;

  > span {
    display: block;
    margin-bottom: 8px;
    color: #1d2735;
    font-size: 14px;
    font-weight: 600;
  }
}

.bid-sheet__input-wrap {
  display: flex;
  height: 50px;
  align-items: center;
  padding: 0 14px;
  border: 1px solid #dfe4eb;
  border-radius: 11px;
  background: #f8f9fb;

  &:focus-within {
    border-color: #5b5bd6;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(91, 91, 214, 0.1);
  }

  > span {
    color: #e5484d;
    font-size: 18px;
    font-weight: 650;
  }

  input {
    width: 100%;
    height: 100%;
    min-width: 0;
    padding-left: 5px;
    border: 0;
    outline: 0;
    background: transparent;
    color: #1d2735;
    font-size: 18px;
    font-weight: 650;
  }
}

.bid-sheet__submit {
  height: 48px;
  margin-top: 14px;
  border-radius: 11px;
  font-size: 16px;
  font-weight: 650;
}

@media (max-width: 359px) {
  .order-card-strict {
    padding: 12px 10px;
  }

  .order-card-bottom {
    gap: 0 7px;
  }

  .movie-img-box {
    margin-right: 8px;
  }

  .movie-img-box .van-image {
    width: 66px !important;
  }

  .bottom-right .bid-btn-strict {
    width: 58px;
  }

  .bid-sheet {
    padding-right: 14px;
    padding-left: 14px;
  }
}

</style>
